import React from 'react';
import './Features.css';

const HotelFeatures = () => {
  return (
    <div className="HotelFeatures">
      <h1>Hotel Features</h1>
      <div className="line"></div>
      <p id="features-description">At Moonside Rooms, we provide top-notch facilities designed for your comfort. Whether you’re here for a relaxing vacation or a business trip, our features will ensure you have a memorable stay.</p>
      <div className="features-list">
        <div className="feature-item">
          <h3>Free Wi-Fi</h3>
          <p>Stay connected with fast and reliable Wi-Fi throughout the property.</p>
        </div>
        <div className="feature-item">
          <h3>On-site Parking</h3>
          <p>We offer parking spaces for all our guests, with a small extra cost ensuring peace of mind during your stay.</p>
        </div>
        <div className="feature-item">
          <h3>Comfy beds</h3>
          <p>Based on 47 reviews, Our Beds are very Comfort.</p>
        </div>
        <div className="feature-item">
          <h3>Flat-screen TV</h3>
          <p>Relax in watching TV on our rooms.</p>
        </div>
      </div>
    </div>
  );
};

export default HotelFeatures;
